import React, {useContext} from "react";

export const Lotto5dContext = React.createContext();

export const useLotto5d = () => useContext(Lotto5dContext);